import React from 'react';
import { PRODUCT_NAME, brandAssets } from '../constants/brand';

export default function BrandLogo({ compact = false, width = compact ? 36 : 196, height = compact ? 36 : 48, style, ...props }) {
  return <img {...props} src={compact ? brandAssets.icon : brandAssets.logo} alt={PRODUCT_NAME}
    width={width} height={height} style={{ display: 'block', objectFit: 'contain', maxWidth: '100%', flexShrink: 0, ...style }} />;
}
